import { render, staticRenderFns } from "./ProblemReturnApplyDialog.vue?vue&type=template&id=f9460d26&scoped=true"
import script from "./ProblemReturnApplyDialog.vue?vue&type=script&lang=js"
export * from "./ProblemReturnApplyDialog.vue?vue&type=script&lang=js"
import style0 from "./ProblemReturnApplyDialog.vue?vue&type=style&index=0&id=f9460d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9460d26",
  null
  
)

export default component.exports